import { useContext } from "react";
import { ZebraPrinterContext } from "./ZebraPrinterProvider";

export function useZebraPrinter() {
  const ctx = useContext(ZebraPrinterContext);
  if (ctx === undefined) {
    throw new Error("useZebraPrinter must be used within a ZebraPrinterProvider");
  }
  return ctx;
}
